<template>
  <div class="sub-footer">
    <div class="grid-container fluid">
      <div class="grid-x grid-margin-x align-center">
        <div class="cell medium-6">
          <div
            v-if="$route.path == '/about'"
            class="sub-footer__text-wrapper"
            data-aos="fade-left"
            data-aos-duration="400"
            data-aos-offset="0"
          >
            <div class="sub-footer__arrow-wrapper sub-footer__arrow-wrapper__left">
              <FontAwesomeIcon icon="play" class="text-purple" />
            </div>
            <p class="sub-footer__text">
              <router-link to="/">Annual Report Home</router-link>
            </p>
          </div>
        </div>
        <div class="cell medium-6 text-right">
          <a
            v-if="$route.path == '/about'"
            href="https://www.svmic.com"
          >
            <div
              class="sub-footer__text-wrapper"
              data-aos="fade-right"
              data-aos-duration="400"
              data-aos-offset="0"
            >
              <p class="sub-footer__text">
                Visit svmic.com
              </p>
              <div class="sub-footer__arrow-wrapper">
                <FontAwesomeIcon icon="play" class="text-purple" />
              </div>
            </div>
          </a>
          <router-link
            v-else
            :to="nextRoute.path"
          >
            <div
              class="sub-footer__text-wrapper"
              data-aos="fade-right"
              data-aos-duration="400"
              data-aos-offset="0"
            >
              <p class="sub-footer__text">
                continue
              </p>
              <div class="sub-footer__arrow-wrapper">
                <FontAwesomeIcon icon="play" class="text-purple" />
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheSubFooter',
  props: {
    nextRoute: Object
  }
};
</script>
